/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleAssignmentRole {
    getFixupPrototypeFunction() { return RoleAssignmentRole.fixupPrototype; }

    static newInstance(model: Partial<RoleAssignmentRole>): RoleAssignmentRole {
        let obj = Object.assign(new RoleAssignmentRole(), model);
        RoleAssignmentRole.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleAssignmentRole>): RoleAssignmentRole {
        if (!model) return null;
        return RoleAssignmentRole.newInstance(<RoleAssignmentRole> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleAssignmentRole) {
        if (!obj) return;

        models.RoleAssignmentRole.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleAssignmentRole): boolean {
        Object.setPrototypeOf(obj, RoleAssignmentRole.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the Role assigned to the user under a tenant
     */
    name: string;

    /**
     * ID of the Role assigned to the user under a tenant
     */
    id: string;

    /**
     * How the role was granted: 'assignment' (directly) or 'usergroup' (inherited from a user group)
     */
    origin: string;

}
